// Saavi Digitex brand mark — theme-aware:
//   • Light mode → official color lockup (JPG, wordmark baked in)
//   • Dark mode  → official white lockup (vector SVG, transparent background)
// Note: the brand's color SVG uses Futura PT type which doesn't fall back cleanly
// in browsers (wordmark overflows the viewBox), so we deliberately use the JPG
// for the color variant — the white SVG is built from vector paths and renders
// perfectly without font dependencies.

import { useTheme } from "@/components/ThemeProvider";

const COLOR_JPG = "https://customer-assets.emergentagent.com/job_saavi-agency/artifacts/rojqw1gr_Logo%20JPEG%20Color.jpg";
const WHITE_SVG = "https://customer-assets.emergentagent.com/job_saavi-agency/artifacts/m2s2agla_Logo%20White%20SVG.svg";

export const SAAVI_BRAND_LOCKUP_URL = COLOR_JPG;
export const SAAVI_BRAND_LOCKUP_WHITE_URL = WHITE_SVG;

export function SaaviMark({ size = 40, className = "", title = "Saavi Digitex", forceVariant }) {
  const { theme } = useTheme();
  const variant = forceVariant || (theme === "dark" ? "white" : "color");
  const isWhite = variant === "white";
  const src = isWhite ? WHITE_SVG : COLOR_JPG;

  // The color JPG has a white background — render directly so it sits on light surfaces.
  // The white SVG is transparent — render directly on dark surfaces.
  return (
    <img
      role="img"
      aria-label={title}
      alt={title}
      src={src}
      draggable={false}
      className={`block object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function SaaviLogo({ size = 44, className = "", forceVariant }) {
  return (
    <span className={`inline-flex items-center ${className}`}>
      <SaaviMark size={size} forceVariant={forceVariant} />
    </span>
  );
}

export default SaaviLogo;
